/* eslint-disable */
import Cookies from 'js-cookie';
// docs https://github.com/js-cookie/js-cookie

// Read allow analytics cookie before setting Google Analytics

export default function() {
  jQuery(function() {
    let cookieBannerClicked = Cookies.get('hasSeenCookieBanner');

    if(cookieBannerClicked) {
      // Init from cookies
      if (Cookies.get('cookie-functional') == "granted"){
        // No need to do anything
      } else {
        Cookies.remove("pll_language");
      }

    } else {
      jQuery('.js-cookie-banner').fadeIn('slow');
      jQuery('.js-cookie-banner').attr('tabindex', '0');
      jQuery('.js-cookie-banner').trigger('focus');
    }

    jQuery('.js-reopen-cookie-banner').on('click', function(e) {
      e.preventDefault()
      openCookieSettings();
    });

    jQuery('.js-close-cookie-banner').on('click', function(e) {
      e.preventDefault()
      Cookies.set('allowanalytics', 'true', { expires: 365 });
      jQuery('.js-cookie-banner').fadeOut('fast');
    });

    jQuery('.js-accept-cookies').on('click', function(e) {
      e.preventDefault()
      Cookies.set('hasSeenCookieBanner', 'true', { expires: 365 });
      jQuery('.js-cookie-banner').fadeOut('fast');

      // Call the update command when your consent status changes
      // (e.g. after a visitor grants consent). Modify the updates per
      // your business requirements and what consent is granted, e.g.:

      Cookies.set("cookie-ads", "granted", { expires: 365 });
      Cookies.set("cookie-analytics", "granted", { expires: 365 });
      Cookies.set("cookie-functional", "granted", { expires: 365 });
    });

    jQuery('.js-settings-cookies').on('click', function(e) {
      e.preventDefault()
      Cookies.set('hasSeenCookieBanner', 'true', { expires: 365 });
      jQuery('.js-cookie-banner').fadeOut('fast');

      jQuery('.main-wrapper').css('opacity', '0.2');

      openCookieSettings();
    });

    jQuery('.js-toggle-cookie-settings').on('click', function(e) {
      e.preventDefault()
      Cookies.set('hasSeenCookieBanner', 'true', { expires: 365 });
      jQuery('.js-cookie-settings').fadeOut('fast');
    });

    // Cookie settings
    function openCookieSettings() {
      var cookieModalBody = jQuery('.cookie-settings__body p');

      jQuery('.js-cookie-settings').fadeIn('fast');
      jQuery('.js-cookie-settings').attr('tabindex', '0');
      jQuery('.js-cookie-settings').trigger('focus');

      // // Check if line-clamp is used
      // if (cookieModalBody[0].scrollHeight > cookieModalBody[0].clientHeight) {
      //   jQuery('.cookie-settings__show-more').show();

      //   jQuery(".cookie-settings__show-more" ).on( "click", function() {
      //       cookieModalBody.css("display", "block");
      //       jQuery('.cookie-settings__show-more').hide();
      //   });
      // }

      // Init selected from cookies
      if (Cookies.get('cookie-ads') == "granted"){
        jQuery(".js-cookie-group input:checkbox[value=ad_storage]").prop('checked', true);
      }

      if (Cookies.get('cookie-analytics') == "granted"){
        jQuery(".js-cookie-group input:checkbox[value=analytics_storage]").prop('checked', true);
      }

      if (Cookies.get('cookie-functional') == "granted"){
        jQuery(".js-cookie-group input:checkbox[value=functional_storage]").prop('checked', true);
      }

      // Save button
      jQuery( ".js-save-cookie-settings" ).on( "click", function() {

        jQuery(".js-cookie-group input").each(function(){

          //console.log(jQuery(this).val());

            if (jQuery(this).val() === 'ad_storage') {
                if (jQuery(this).prop('checked') == true) {
                    Cookies.set("cookie-ads", "granted", { expires: 365 });
                } else {
                    Cookies.set("cookie-ads", "denied", { expires: 365 });
                    Cookies.remove('_ga', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                    Cookies.remove('_gid', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                }
            }

            if (jQuery(this).val() === 'analytics_storage') {
                if (jQuery(this).prop('checked') == true) {
                    Cookies.set("cookie-analytics", "granted", { expires: 365 });
                } else {
                    Cookies.set("cookie-analytics", "denied", { expires: 365 });
                    Cookies.remove('_ga', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                    Cookies.remove('_gid', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                }
            }

            if (jQuery(this).val() === 'functional_storage') {
                if (jQuery(this).prop('checked') == true) {
                    Cookies.set("cookie-functional", "granted", { expires: 365 });
                } else {
                    Cookies.remove("pll_language");
                    Cookies.set("cookie-functional", "denied", { expires: 365 });
                }
            }
        });
        jQuery('.main-wrapper').css('opacity', '1');
        jQuery('.js-cookie-settings').fadeOut('fast');
      });
    }

  });

}

/* eslint-enable */
